import { apiRequest } from "../../../services/api";
import { ILogin } from "../type/loginType";

export const login = async (data: ILogin) => {
  const response = await apiRequest<ILogin>("POST", "/auth/login", {
    email: data.email,
    password: data.password,
  });
  return response.data;
};
